import { inject, Injectable } from '@angular/core';
import { LocalService } from '@sites/util-storage';

const STORAGE_KEY = 'HMM_DEBUG';

@Injectable({ providedIn: 'root' })
export class DebugService {
  private localStorage = inject(LocalService);

  isDebug(): boolean {
    try {
      return !!this.localStorage.read(STORAGE_KEY);
    } catch {
      return false;
    }
  }
}
